import {z} from 'zod'
import {CONDITION_OPERATORS} from '../utils/conditions.js'

/** Groups of conditions on the given variables of an object, see server/utils/conditions.ts */
export const conditionGroupsModel = <T extends readonly [string, ...string[]]>(variables: T) => z.array(
    z.array(z.object({
        variable: z.enum(variables),
        operator: z.enum(CONDITION_OPERATORS),
        value: z.union([z.string(), z.number(), z.boolean(), z.array(z.string())])
    }))
).default([])
